import { Injectable } from '@angular/core';

@Injectable()
export class IEService {
  protected _isIE: boolean = null;
  private readonly PDF_SUFFIX = ".pdf";

  constructor() { }

  public isIE(): boolean {
    if (this._isIE === null) {
      this._isIE = IEService.runIECheck();
    }
    return this._isIE;
  }

  public static runIECheck(): boolean {
    const ua = navigator.userAgent;
    if (ua) {
      const is_ie = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
      return is_ie;
    }
    return false;
  }

  public openPDF(blob: Blob, blobURL: string) {
    if(!blobURL.endsWith(this.PDF_SUFFIX)) {
      blobURL += this.PDF_SUFFIX;
    }
    (window.navigator as any).msSaveOrOpenBlob(blob, blobURL);
  }

  public savePDF(blob: Blob, blobURL: string) {
    if(!blobURL.endsWith(this.PDF_SUFFIX)) {
      blobURL += this.PDF_SUFFIX;
    }
    (window.navigator as any).msSaveBlob(blob, blobURL);
  }
}
